import { useEffect, useState } from 'react';

export function useChartSize(containerRef, { minWidth = 80, minHeight = 80 } = {}) {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const node = containerRef.current;
        if (!node) return;

        const update = () => {
            const width = Math.floor(node.clientWidth);
            const height = Math.floor(node.clientHeight);
            if (width >= minWidth && height >= minHeight) {
                setSize((prev) => (
                    prev.width === width && prev.height === height
                        ? prev
                        : { width, height }
                ));
            }
        };

        update();
        const observer = new ResizeObserver(() => requestAnimationFrame(update));
        observer.observe(node);
        window.addEventListener('resize', update);

        return () => {
            observer.disconnect();
            window.removeEventListener('resize', update);
        };
    }, [minWidth, minHeight]);

    return size;
}

export function useChartWidth(containerRef, minWidth = 80) {
    return useChartSize(containerRef, { minWidth, minHeight: 0 }).width;
}
